module.exports = __webpack_public_path__ + "static/media/rdsr_kt.24cd62b1.svg";